/* eslint-disable react/prop-types */
import React from 'react';

import { Table } from '@devexpress/dx-react-grid-material-ui';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import ReactSelect from 'react-select';

import { DataTypeProvider } from '@devexpress/dx-react-grid';

const PREFIX = 'Demo';
const classes = {
  lookupEditCell: `${PREFIX}-lookupEditCell`,
  dialog: `${PREFIX}-dialog`,
  inputRoot: `${PREFIX}-inputRoot`,
  selectMenu: `${PREFIX}-selectMenu`
};
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${classes.lookupEditCell}`]: {
    padding: theme.spacing(1)
  },
  [`& .${classes.dialog}`]: {
    width: 'calc(100% - 16px)'
  },
  [`& .${classes.inputRoot}`]: {
    width: '100%'
  },
  [`& .${classes.selectMenu}`]: {
    position: 'absolute !important'
  }
}));

const UserTableLookupEditCell = ({ availableColumnValues, value, onValueChange, column, onBlur, autoFocus }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const columnName = column.name;

  const options = (availableColumnValues[columnName] || []).map((item) => {
    return {
      value: item.name || item.label || item.value || item,
      label: item.name || item.label || item.value || item,
      id: item.id || item.value || item
    };
  });

  const displayValue = value?.name || value?.label || value || '';
  const dropdownValue = displayValue ? { value: displayValue, label: displayValue } : null;
  return (
    <>
      <StyledTableCell className={classes.lookupEditCell}>
        <ReactSelect
          onBlur={isSmall ? null : onBlur} //blur doesn't work in mobile phones
          autoFocus={autoFocus}
          className="basic-single"
          classNamePrefix="select"
          value={dropdownValue}
          isSearchable={true}
          name="color"
          options={options}
          isClearable={true}
          // eslint-disable-next-line no-undef
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          onChange={(selectedOption) => {
            if (selectedOption === null) {
              // Handle the case when the selected option is cleared
              onValueChange(null); // or handle it based on your requirements
            } else {
              if (columnName === 'vendorRef' || columnName === 'itemRef' || columnName === 'taxType') {
                onValueChange({ name: selectedOption.value, value: selectedOption.id });
              } else {
                onValueChange(selectedOption.value);
              }
            }
          }}
        />
      </StyledTableCell>
    </>
  );
};

//in focusable cell: if required field is empty; should not hit updates on the backend and show error border from table
export const FocusableCell = ({
  onClick,
  invalidRows = [],
  setInvalidRows = () => {},
  validationStatus = {},
  setValidationStatus = () => {},
  ...restProps
}) => {
  const { row, column } = restProps;
  const isInvalidRow = invalidRows.includes(row.id);
  const fieldStatus = validationStatus[row.id]?.[column.name];
  const isFieldInvalid = fieldStatus?.isValid === false;

  const handleCellClick = () => {
    // Check if the clicked row is invalid, and if so, remove the styles and remove from invalidRows.
    if (isInvalidRow) {
      restProps.style = {};
      const clickedRowId = row.id;

      const updatedInvalidRows = invalidRows.filter((id) => id !== clickedRowId);
      setInvalidRows(updatedInvalidRows);
    }
    if (isFieldInvalid) {
      setValidationStatus((prev) => ({
        ...prev,
        [row.id]: { ...prev[row.id], [column.name]: undefined }
      }));
    }
    onClick();
  };

  const commonStyle = {
    ...restProps.style,
    border: isInvalidRow || isFieldInvalid ? '1px solid red' : restProps.style?.border,
    cursor: isInvalidRow ? 'pointer' : restProps.style?.cursor
  };
  const title = isFieldInvalid ? fieldStatus.error : undefined;

  if (
    column.name === 'vendorRef' ||
    column.name === 'itemRef' ||
    column.name === 'taxType' ||
    column.name === 'userRole'
  ) {
    return <Table.Cell {...restProps} tabIndex={0} onFocus={handleCellClick} style={commonStyle} title={title} />;
  }

  return <Table.Cell {...restProps} tabIndex={0} onFocus={onClick} style={commonStyle} title={title} />;
};

export const LookupFormatter = ({ availableColumnValues, ...props }) => (
  <DataTypeProvider
    editorComponent={(params) => <UserTableLookupEditCell availableColumnValues={availableColumnValues} {...params} />}
    {...props}
  />
);

export default LookupFormatter;
